<template>

    <div>

        <h2 class="pb-4">Network</h2>

        <div class="col">
            <template v-if="!checked">
                <sau-loading></sau-loading>
            </template>
            <template v-if="showBandwidth && checked">
                <h5>24-hour History</h5>
                <img :src="bandwidthGraphUrl">
            </template>
        </div>

    </div>
</template>

<script>
export default {
    props: ['service'],
    data() {
        return {
            showPorts: false,
            bandwidthGraphUrl: '',
            showBandwidth: false,
            checked: false,
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getCurrentBandwidthUsage().then(response => {
                this.checked = true;
                if (response.data) {
                    if (response.data.status == 'success') {
                        this.bandwidthGraphUrl = response.data.trafficgraph;
                        this.showBandwidth = true;
                        this.checked = true;
                    } else {
                        this.showBandwidth = false;
                        this.checked = true;
                    }
                }
            })
        }
    },
    computed: {
    }
}
</script>
